
<template>
    <div class="bar-preloader">
        <div class="indeterminate"></div>
    </div>
</template>


<script>
export default {
    name: 'barPreloader',
    //props: ['dataList'],
    methods: {
    },
	mounted: function(){
	},
	updated: function(){
	}
    
}
</script>



// WEBPACK FOOTER //
// src/js/vue/components/barPreloader.vue?9fbaa286